const STATUS_LABELS = {
  draft: 'Draft',
  ready: 'Ready',
  sending: 'Sending',
  sent: 'Sent',
  failed: 'Failed',
  cancelled: 'Cancelled',
};

const STATUS_BADGES = {
  draft: 'bg-secondary-subtle text-secondary',
  ready: 'bg-info-subtle text-info',
  sending: 'bg-warning-subtle text-warning',
  sent: 'bg-success-subtle text-success',
  failed: 'bg-danger-subtle text-danger',
  cancelled: 'bg-light text-muted',
};

function normalizeText(value) {
  return String(value || '').trim();
}

function formatDateTime(value) {
  const raw = normalizeText(value);
  if (!raw) {
    return '-';
  }
  const date = new Date(raw);

  return Number.isNaN(date.getTime()) ? raw : date.toLocaleString();
}

export function buildMarketingEmailCampaignRows(campaigns = []) {
  return (Array.isArray(campaigns) ? campaigns : []).map((campaign, index) => {
    const status = normalizeText(campaign?.status || 'draft') || 'draft';
    const uid = normalizeText(campaign?.uid);

    return {
      ...campaign,
      id: uid || `campaign-${index + 1}`,
      key: uid || `campaign-${index + 1}`,
      status,
      statusLabel: STATUS_LABELS[status] || status,
      statusBadgeClass: STATUS_BADGES[status] || 'bg-light text-muted',
      sentAtLabel: formatDateTime(campaign?.sentAt),
      recipientsLabel: `${Number(campaign?.sentCount || 0)} sent / ${Number(campaign?.selectedCount || 0)} selected`,
      canEdit: status === 'draft' || status === 'ready',
      canSend: status === 'draft' || status === 'ready',
    };
  });
}

export function filterMarketingEmailCampaignRows(rows, search = '') {
  const query = normalizeText(search).toLowerCase();
  if (!query) {
    return Array.isArray(rows) ? rows : [];
  }

  return (Array.isArray(rows) ? rows : []).filter((row) => [
    row.name,
    row.subject,
    row.statusLabel,
  ].some((value) => normalizeText(value).toLowerCase().includes(query)));
}
